export default "//file.bilionpass.com/japandx-web/0.0.1/static/attention_icon.55eeb62e-508aa3.svg";